/* Smart Strips product story sections (ss-zen-*, ss-ticker). No dependencies.
   - Animations run only while their section is on screen ([data-ss-anim] gets .is-off when out of view).
   - Dose path and benefit wheel are driven here; hero, dissolve, price marker and ticker are CSS.
   - Add to cart buttons reuse the main product form when it is on the page (keeps the
     buy box's variant, subscription choice and cart drawer); otherwise they post normally. */
(function () {
  if (window.ssZen) return;
  window.ssZen = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var controllers = new WeakMap();

  /* ---------- Dose path: pill vs strip ---------- */
  function pathController(root) {
    var svg = root.querySelector('svg');
    var finals = root.querySelectorAll('.ss-zen-path__final p');
    var NDOT = 10, SP = 10, DR = 4, L0 = 40, L1 = 506, MOVE = 3850, HOLD = 4200;
    var NS = 'http://www.w3.org/2000/svg';
    var lanes = [].map.call(root.querySelectorAll('[data-lane]'), function (g) {
      var n = +g.getAttribute('data-nodes');
      var X = [];
      for (var i = 0; i < n; i++) X.push(L0 + (L1 - L0) * i / (n - 1));
      var loss = JSON.parse(g.getAttribute('data-loss'));
      var dots = [];
      var layer = g.querySelector('.dots');
      for (var k = 0; k < NDOT; k++) {
        var c = document.createElementNS(NS, 'circle');
        c.setAttribute('r', DR);
        layer.appendChild(c);
        dots.push(c);
      }
      return {
        y: +g.getAttribute('data-y'), X: X, loss: loss, dots: dots,
        color: g.getAttribute('data-color'), labc: g.getAttribute('data-labc'),
        line: g.querySelector('.prog'), nodes: g.querySelectorAll('.node'), labels: g.querySelectorAll('.nl, .ns'),
        endNode: g.querySelector('.endnode'), glow: g.querySelector('.glow'), endLabel: g.querySelector('.el'),
        endText: g.querySelector('.end')
      };
    });

    function drawLane(L, prog) {
      var X = L.X, span = X[X.length - 1] - X[0];
      var lead = X[0] + prog * (span + (NDOT - 1) * SP);
      var xe = X[X.length - 1];
      L.line.setAttribute('x2', Math.max(X[0], Math.min(lead, xe)));
      L.line.style.opacity = prog > 0 ? 1 : 0;
      var arrived = 0;
      for (var i = 0; i < NDOT; i++) {
        var c = L.dots[i], pos = lead - i * SP, lossAt = L.loss[i];
        c.style.display = 'none';
        if (pos < X[0]) continue;
        if (lossAt !== undefined && pos >= X[lossAt]) {
          var dd = pos - X[lossAt], a = 1 - dd / 34;
          if (a > 0) {
            c.style.display = '';
            c.setAttribute('cx', X[lossAt] + dd * 0.25);
            c.setAttribute('cy', L.y + dd * 0.7);
            c.setAttribute('r', DR * 0.9);
            c.setAttribute('fill', '#6E6E6E');
            c.style.opacity = a;
          }
          continue;
        }
        if (pos >= xe) { arrived++; continue; }
        c.style.display = '';
        c.setAttribute('cx', pos);
        c.setAttribute('cy', L.y);
        c.setAttribute('r', DR);
        c.setAttribute('fill', L.color);
        c.style.opacity = 1;
      }
      for (var j = 0; j < L.nodes.length; j++) {
        var reached = X[j] <= lead + 1;
        L.nodes[j].setAttribute('stroke', reached ? L.labc : '#464C58');
      }
      [].forEach.call(L.labels, function (t) {
        var reached = +t.getAttribute('x') <= lead + 1;
        t.setAttribute('fill', reached ? L.labc : '#5F6470');
      });
      var r = 7 + arrived * 1.45;
      L.endNode.setAttribute('r', r);
      L.endNode.setAttribute('fill', arrived ? L.color : '#121419');
      L.endNode.setAttribute('stroke', arrived ? L.color : '#464C58');
      L.glow.setAttribute('r', r + 8);
      L.glow.style.opacity = arrived ? 1 : 0;
      L.endLabel.setAttribute('y', L.y + Math.max(32, r + 24));
      L.endLabel.setAttribute('fill', arrived ? L.labc : '#5F6470');
      L.endText.style.opacity = lead >= xe + (NDOT - 1) * SP ? 1 : 0;
    }

    function frame(t) {
      t = t % (MOVE + HOLD);
      var tp = Math.min(1, t / MOVE);
      drawLane(lanes[0], tp);
      drawLane(lanes[1], Math.min(1, tp * 4));
      var done = t >= MOVE;
      for (var i = 0; i < finals.length; i++) finals[i].style.opacity = done ? 1 : 0;
    }

    var raf = 0, start = 0, elapsed = 0;
    function loop(now) {
      if (!start) start = now - elapsed;
      elapsed = now - start;
      frame(elapsed);
      raf = requestAnimationFrame(loop);
    }
    frame(0);
    return {
      play: function () { if (!raf) { start = 0; raf = requestAnimationFrame(loop); } },
      pause: function () { cancelAnimationFrame(raf); raf = 0; }
    };
  }

  /* ---------- Benefit wheel: one segment lit at a time ---------- */
  function wheelController(root) {
    var segs = root.querySelectorAll('.seg');
    var i = 0, timer = 0;
    function show() {
      for (var k = 0; k < segs.length; k++) segs[k].classList.toggle('is-active', k === i);
    }
    show();
    return {
      play: function () {
        if (timer) return;
        timer = setInterval(function () { i = (i + 1) % segs.length; show(); }, 1100);
      },
      pause: function () { clearInterval(timer); timer = 0; }
    };
  }

  function setup(el) {
    var kind = el.getAttribute('data-ss-anim');
    if (reduce) {
      if (kind === 'wheel') el.querySelectorAll('.seg.is-active').forEach(function (s) { s.classList.remove('is-active'); });
      return;
    }
    var c = null;
    if (kind === 'path') c = pathController(el);
    if (kind === 'wheel') c = wheelController(el);
    controllers.set(el, c);
    if (!io) { if (c) c.play(); return; }
    el.classList.add('is-off');
    io.observe(el);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var c = controllers.get(e.target);
      e.target.classList.toggle('is-off', !e.isIntersecting);
      if (c) e.isIntersecting ? c.play() : c.pause();
    });
  }, { threshold: 0.35 }) : null;

  /* ---------- Ticker: 50 px per second ---------- */
  function setupTicker(t) {
    var track = t.querySelector('.ss-zen-ticker__track');
    var group = t.querySelector('.ss-zen-ticker__group');
    if (!track || !group) return;
    function size() {
      var w = group.getBoundingClientRect().width;
      if (w) track.style.setProperty('--ss-tick-dur', (w / 50) + 's');
    }
    size();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(size);
  }

  /* ---------- Buttons ---------- */
  function mainForm() {
    var btns = document.querySelectorAll('product-form [type="submit"], .product-form__submit');
    for (var i = 0; i < btns.length; i++) if (!btns[i].closest('.ss-zen')) return btns[i];
    return null;
  }
  function buyBox() {
    var b = mainForm();
    return b ? (b.closest('.shopify-section') || b) : null;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-ss-atc]')) return;
    var btn = mainForm();
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.click();
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ss-scroll]');
    if (!a) return;
    var target = buyBox();
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  function init(scope) {
    scope.querySelectorAll('[data-ss-anim]').forEach(function (el) {
      if (el.dataset.ssReady) return;
      el.dataset.ssReady = '1';
      setup(el);
    });
    scope.querySelectorAll('.ss-zen-ticker').forEach(setupTicker);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
